import { render } from "./Registro.vue?vue&type=template&id=1a4399f4&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=1a4399f4&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4399f4"]])

export default __exports__